import React from "react";
import {
  CartesianCoordinate,
  CylindricalCoordinate,
} from "../../../Model/Coordinate";
import TextBox from "../../Common/TextBox";
import "./WaypointOffset.css";

interface Props<T extends CartesianCoordinate | CylindricalCoordinate> {
  forwardOffset: T;
  setForwardOffsetHandler: (fwdOffset: T) => void;
  reverseOffset: T;
  setReverseOffsetHandler: (revOffset: T) => void;
  isApplyOffsetWhileTuning: boolean;
  setIsApplyOffsetWhileTuning: (state: boolean) => void;
}

const WaypointOffset = <
  T extends CartesianCoordinate | CylindricalCoordinate
>({
  forwardOffset,
  setForwardOffsetHandler,
  reverseOffset,
  setReverseOffsetHandler,
  isApplyOffsetWhileTuning,
  setIsApplyOffsetWhileTuning,
}: Props<T>) => {
  return (
    <div className="waypoint-offset">
      <span
        style={{
          textAlign: "left",
          gridArea: "title",
        }}
      >
        Offsets
      </span>
      <div
        className="tuning-checkbox"
        style={{
          gridArea: "tuning",
        }}
      >
        <label
          style={{
            fontSize: "12px",
            lineHeight: "20px",
          }}
          htmlFor="tuning"
        >
          Apply offset while tuning
        </label>
        <input
          type="checkbox"
          id="tuning"
          name="tuning"
          checked={isApplyOffsetWhileTuning}
          onChange={() =>
            setIsApplyOffsetWhileTuning(!isApplyOffsetWhileTuning)
          }
        />
      </div>
      <div
        style={{
          gridArea: "table",
        }}
      >
        <table>
          <thead>
            <tr>
              <th>Axis</th>
              <th>Forward</th>
              <th>Reverse</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(forwardOffset).map((axis) => {
              let index = axis as keyof typeof forwardOffset;
              let fwdOffsetOriginalVal = forwardOffset[index];
              let fwOffsetVal = fwdOffsetOriginalVal as unknown as string;

              let reverseOffsetOriginalVal = reverseOffset[index];
              let reverseOffsetval =
                reverseOffsetOriginalVal as unknown as string;

              return (
                <tr key={axis+fwOffsetVal+reverseOffsetval}>
                  <td>{axis.toUpperCase()}</td>
                  <td>
                    <TextBox
                      isInteger={false}
                      name={axis + "Forward"}
                      value={fwOffsetVal}
                      onChange={(value) => {
                        forwardOffset[index] =
                          value as unknown as typeof fwdOffsetOriginalVal;
                        setForwardOffsetHandler(forwardOffset);
                      }}
                    />
                  </td>
                  <td>
                    <TextBox
                      isInteger={false}
                      name={axis + "Reverse"}
                      value={reverseOffsetval}
                      onChange={(value) => {
                        reverseOffset[index] =
                          value as unknown as typeof reverseOffsetOriginalVal;
                        setReverseOffsetHandler(reverseOffset);
                      }}
                    />
                  </td>
                </tr>
              )
            }
            )
            }
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default WaypointOffset;
